export enum HighlightChat {
  TWENTYFOUR_SEVEN_LIVE_CHAT = 'twentyfour-seven-live-chat',
  INSTANT_MATH_HELP = 'instant-math-help',
  K_12_CURRICULUM = 'k-12-curriculum',
}

export enum HighlightVideoChat {
  LIVE_VIDEO_CHAT = 'live-video-chat',
  FIFTEEN_MINUTES_EXPRESS_HELP = 'fifteen-minutes-express-help',
  OPEN_EVERY_DAY = 'open-every-day',
  CHOOSE_BETWEEN_LANGUAGES = 'choose-between-languages',
}

export enum HighlightPrivateTutor {
  PERSONAL_FOLLOW_UP = 'personal-follow_up',
  PERSONAL_LEARNING_PLAN = 'personal-learning-plan',
  TAILOR_MADE_TRAINING = 'tailor-made-training',
  FLEXIBLE_SCHEDULE = 'flexible-schedule',
  DIGITAL_OR_PHYSICAL = 'digital-or-physical',
}
